import React from 'react';
import { Box, Divider } from '@mui/material';
import Hai from './Hai';
import { HAI_TYPES } from '../haiUtils';

const styles = {
  palette: {
    padding: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#f5f5f5',
    marginBottom: '10px',
  },
  haiContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  hai: {
    // 10牌が1行に収まるようにし、最大幅を35pxに制限
    width: '9.8%',
    maxWidth: '35px',
    height: 'auto',
    padding: '0 2px',
    boxSizing: 'border-box',
  },
};

const HaiPalette = ({ onHaiClick }) => {
  return (
    <Box sx={styles.palette}>
      {/* 筒子 + 赤5筒 */}
      <Box sx={styles.haiContainer}>
        {HAI_TYPES.PINZU.map((id) => (
          <Box key={id} onClick={() => onHaiClick(id)} sx={{ ...styles.hai, cursor: 'pointer' }}>
            <Hai haiId={id} />
          </Box>
        ))}
        <Box key={HAI_TYPES.AKA[0]} onClick={() => onHaiClick(HAI_TYPES.AKA[0])} sx={{ ...styles.hai, cursor: 'pointer' }}>
          <Hai haiId={HAI_TYPES.AKA[0]} />
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      {/* 索子 + 赤5索 */}
      <Box sx={styles.haiContainer}>
        {HAI_TYPES.SOUZU.map((id) => (
          <Box key={id} onClick={() => onHaiClick(id)} sx={{ ...styles.hai, cursor: 'pointer' }}>
            <Hai haiId={id} />
          </Box>
        ))}
        <Box key={HAI_TYPES.AKA[1]} onClick={() => onHaiClick(HAI_TYPES.AKA[1])} sx={{ ...styles.hai, cursor: 'pointer' }}>
          <Hai haiId={HAI_TYPES.AKA[1]} />
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      {/* 萬子 + 字牌 */}
      <Box sx={styles.haiContainer}>
        {HAI_TYPES.MANZU.map((id) => (
          <Box key={id} onClick={() => onHaiClick(id)} sx={{ ...styles.hai, cursor: 'pointer' }}>
            <Hai haiId={id} />
          </Box>
        ))}
        {HAI_TYPES.JIHAI.map((id) => (
          <Box key={id} onClick={() => onHaiClick(id)} sx={{ ...styles.hai, cursor: 'pointer' }}>
            <Hai haiId={id} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HaiPalette;
